/* Native product-detail recommendation analytics.
   Product recommendations are public Shopify reads. */

(function () {
  document.addEventListener('click', function (event) {
    var recommendation = event.target.closest('[data-gettmi-recommendation-card]');
    if (
      recommendation &&
      typeof window.gettmiAnalyticsAllowed === 'function' &&
      window.gettmiAnalyticsAllowed() &&
      typeof window.gtag === 'function'
    ) {
      window.gtag('event', 'recommendation_product_opened', {
        position: Number(recommendation.dataset.position || 0),
        product_path: recommendation.getAttribute('href') || '',
        product_title: recommendation.dataset.title || '',
        source: 'product_detail',
        vendor: recommendation.dataset.vendor || ''
      });
    }
  });
})();
